"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Translate_1 = __importStar(require("../Translate/Translate"));

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var SearchBar_1 = __importDefault(require("./styledComponents/SearchBar"));

var SearchIcon_1 = __importDefault(require("./styledComponents/SearchIcon"));

var ResultBackground_1 = __importDefault(require("./styledComponents/ResultBackground"));

var ResultCard_1 = __importDefault(require("./styledComponents/ResultCard"));

var SearchResultElement_1 = __importDefault(require("./SearchResultElement"));

var ResultGroup_1 = __importDefault(require("./styledComponents/ResultGroup"));

var ResultGroupWrapper_1 = __importDefault(require("./styledComponents/ResultGroupWrapper"));

var SearchResultGroupElement_1 = __importDefault(require("./SearchResultGroupElement"));

var SearchPill_1 = __importDefault(require("./styledComponents/SearchPill"));

var SearchClear_1 = __importDefault(require("./styledComponents/SearchClear"));

var SelectedResultClear_1 = __importDefault(require("./styledComponents/SelectedResultClear"));

var SelectedResultPill_1 = __importDefault(require("./styledComponents/SelectedResultPill"));

var SelectedResultsWrapper_1 = __importDefault(require("./styledComponents/SelectedResultsWrapper"));

var SelectedResultGroup_1 = __importDefault(require("./styledComponents/SelectedResultGroup"));

var SelectedResultValue_1 = __importDefault(require("./styledComponents/SelectedResultValue"));

var Input_1 = __importDefault(require("../Input"));

var SearchStore_1 = __importDefault(require("./SearchStore"));

var Search_meta_1 = require("./Search.meta");

var mobx_1 = require("mobx");

var Label_1 = __importDefault(require("../Label"));

var VisuallyHidden_1 = __importDefault(require("../VisuallyHidden"));

var sortByFunction = ksys_app_template_1.utils.collection.sortBy;
var SEARCH_ACTIONS = ['UPDATED_TERM', 'UPDATED_RESULTS', 'UPDATED_RESULT_DISPLAY', 'UPDATED_SEARCH_STATUS', 'UPDATED_PILL_PROPS'];
var NAVIGATION_KEYS = [shared_1.KEYS.ESCAPE, shared_1.KEYS.UP_ARROW, shared_1.KEYS.DOWN_ARROW, shared_1.KEYS.PAGE_UP, shared_1.KEYS.PAGE_DOWN, shared_1.KEYS.HOME, shared_1.KEYS.END];
var ACCEPT_KEYS = [shared_1.KEYS.ENTER, shared_1.KEYS.SPACE, shared_1.KEYS.SPACEBAR];

var Search =
/** @class */
function (_super) {
  __extends(Search, _super);

  function Search(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = Search_meta_1.SEARCH_CATEGORY_KEY;
    _this.componentKey = Search_meta_1.SEARCH_COMPONENT_KEY;
    _this.focusedIndex = -1;

    _this.handleKeyDown = function (e, record) {
      var key = e.key;

      if (NAVIGATION_KEYS.indexOf(key) !== -1) {
        e.preventDefault();
        e.stopPropagation();

        _this.onNavigation(key);
      } else if (ACCEPT_KEYS.indexOf(key) !== -1 && !_this.SearchStore.showResults && !_this.props.ignoreAcceptanceKeys) {
        e.preventDefault();
        _this.SearchStore.showResults = true;
      } else if (key === shared_1.KEYS.TAB) {
        _this.focusedIndex = -1;
        _this.SearchStore.showResults = false;
        _this.focusSearchInput = true;
      } else if (ACCEPT_KEYS.indexOf(key) !== -1 && _this.results.length > 0 && _this.focusedIndex >= 0 && _this.SearchStore.showResults) {
        e.stopPropagation();
        e.preventDefault();
        _this.focusedIndex = -1;

        _this.SearchStore.clickRecord(record);

        _this.SearchStore.showResults = false;
        _this.focusSearchInput = true;
      }
    };

    _this.handlePillKeyDown = function (e, record) {
      var key = e.key;

      if (ACCEPT_KEYS.indexOf(key) !== -1) {
        e.preventDefault();

        _this.removeSelectedResult(record);
      }
    };

    var guid = ksys_app_template_1.utils.guid.generateGuid();
    _this.searchBarId = "searchBar_" + guid;
    _this.searchInputId = "searchInput_" + guid;
    _this.searchLabelId = "searchLabel_" + guid;
    _this.onChange = _this.onChange.bind(_this);
    _this.updateLastAction = _this.updateLastAction.bind(_this);
    _this.SearchStore = new SearchStore_1.default(_this.updateLastAction, props);
    return _this;
  }

  Search.prototype.componentDidUpdate = function (prevProps, prevState) {
    var _a = this.props,
        term = _a.term,
        pillProps = _a.pillProps;
    this.SearchStore.setupPillProps(pillProps);

    if (term) {
      this.SearchStore.setTerm(term);
    }

    this.SearchStore.selectedResults = this.props.selectedResults || [];
  };

  Search.prototype.onChange = function (e) {
    var _this = this;

    var searchCallback = this.props.searchCallback;
    var searchTerm = ksys_app_template_1.utils.object.safe(function () {
      return e.target.value;
    }, '') || '';
    this.SearchStore.setTerm(searchTerm);

    if (searchCallback && searchTerm.length >= this.minCharacterTrigger) {
      this.SearchStore.setIsSearching(true); // debounce

      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = undefined;
      }

      this.timeout = setTimeout(function () {
        _this.SearchStore.fetchResults();
      }, this.onChangeMillisecondTimeout);
    } else {
      this.SearchStore.hideResults();
      this.SearchStore.resetPillProps();
    }
  };

  Search.prototype.updateLastAction = function (action) {
    this.lastAction = action;
  };

  Object.defineProperty(Search.prototype, "term", {
    get: function get() {
      return this.SearchStore.term;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Search.prototype, "isSearching", {
    get: function get() {
      return this.SearchStore.isSearching;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Search.prototype, "pillProps", {
    get: function get() {
      return this.SearchStore.pillProps;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Search.prototype, "selectedResults", {
    get: function get() {
      return this.SearchStore.selectedResults;
    },
    enumerable: true,
    configurable: true
  });

  Search.prototype.removeSelectedResult = function (record) {
    return this.SearchStore.removeSelectedResult(record);
  };

  Object.defineProperty(Search.prototype, "results", {
    get: function get() {
      return this.SearchStore.results;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Search.prototype, "sortedResults", {
    // Sort results so that the focused index follows a logical order on the UI
    get: function get() {
      var sortBy = function sortBy(result) {
        return "" + (result.group || '') + result.value;
      };

      var sortedResults = sortByFunction(this.results, sortBy, 'ASC');
      return sortedResults;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Search.prototype, "groupedResults", {
    get: function get() {
      var groupedResults = {};

      for (var _i = 0, _a = this.sortedResults; _i < _a.length; _i++) {
        var result = _a[_i];
        var _b = result.group,
            group = _b === void 0 ? '' : _b;

        if (!groupedResults[group]) {
          groupedResults[group] = [];
        }

        groupedResults[group].push(result);
      }

      return groupedResults;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Search.prototype, "minCharacterTrigger", {
    get: function get() {
      return this.props.minCharacterTrigger || 3;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Search.prototype, "onChangeMillisecondTimeout", {
    get: function get() {
      return this.props.onChangeMillisecondTimeout || 1000;
    },
    enumerable: true,
    configurable: true
  });

  Search.prototype.getAsset = function (isSearching) {
    return isSearching ? 'base.search.spinner' : 'base.search.magnificationGlass';
  };

  Object.defineProperty(Search.prototype, "resultGroupedElements", {
    get: function get() {
      var _this = this;

      var ResultItemComponent = this.props.resultItemComponent;
      var groups = Object.keys(this.groupedResults);
      return groups.map(function (group, index) {
        var resultGroupId = "result-group-" + index;
        return react_1.default.createElement("div", {
          role: 'list'
        }, react_1.default.createElement(ResultGroup_1.default, {
          id: resultGroupId,
          key: resultGroupId
        }, react_1.default.createElement(Translate_1.default, null, group)), react_1.default.createElement(ResultGroupWrapper_1.default, {
          role: 'list',
          "aria-labelledby": resultGroupId,
          key: "result-group-wrapper-" + index
        }, _this.groupedResults[group].map(function (record, index2) {
          record.focused = _this.sortedResults.indexOf(record) === _this.focusedIndex;
          var resultGroupElementId = "result-element-" + index2;
          return react_1.default.createElement(SearchResultGroupElement_1.default, {
            key: resultGroupElementId,
            id: resultGroupElementId,
            item: record,
            isOpen: _this.SearchStore.showResults,
            onClick: function onClick() {
              return _this.SearchStore.clickRecord(record);
            },
            onKeyDown: function onKeyDown(e) {
              return _this.handleKeyDown(e, record);
            },
            role: 'text'
          }, ResultItemComponent ? react_1.default.createElement(ResultItemComponent, {
            record: record
          }) : react_1.default.createElement(Translate_1.default, null, record.value));
        })));
      });
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Search.prototype, "resultElements", {
    get: function get() {
      var _this = this;

      var ResultItemComponent = this.props.resultItemComponent;
      var showResults = this.SearchStore.showResults;
      return this.results.map(function (record, index) {
        record.focused = index === _this.focusedIndex;
        var resultElementId = "result-element-" + index;
        return react_1.default.createElement(SearchResultElement_1.default, {
          key: resultElementId,
          id: resultElementId,
          item: record,
          isOpen: showResults,
          onClick: function onClick() {
            return _this.SearchStore.clickRecord(record);
          },
          onKeyDown: function onKeyDown(e) {
            return _this.handleKeyDown(e, record);
          }
        }, ResultItemComponent ? react_1.default.createElement(ResultItemComponent, {
          record: record
        }) : record.value);
      });
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Search.prototype, "resultElementsComponent", {
    get: function get() {
      var _a = this.props.groupSearchResults,
          groupSearchResults = _a === void 0 ? false : _a;
      var showResults = this.SearchStore.showResults;
      var resultContents;

      if (groupSearchResults) {
        resultContents = this.resultGroupedElements;
      } else {
        resultContents = this.resultElements;
      }

      var resultCardComponent = react_1.default.createElement(ResultCard_1.default, {
        role: "combo",
        "aria-live": 'polite'
      }, resultContents);

      if (showResults) {
        return resultCardComponent;
      }

      return react_1.default.createElement(VisuallyHidden_1.default, null, resultCardComponent);
    },
    enumerable: true,
    configurable: true
  });

  Search.prototype.getPlaceholder = function (translationContext) {
    var placeholder = this.props.placeholder;
    return placeholder ? translationContext.translate(placeholder) : placeholder;
  };

  Search.prototype.getAutoFocus = function () {
    var autoFocus = false;

    if (this.lastAction !== undefined && SEARCH_ACTIONS.indexOf(this.lastAction) >= 0) {
      this.lastAction = undefined;
      autoFocus = true;
    }

    return autoFocus;
  };

  Object.defineProperty(Search.prototype, "searchLabel", {
    get: function get() {
      var _a = this.props,
          _b = _a.label,
          label = _b === void 0 ? 'Search' : _b,
          _c = _a.hideLabel,
          hideLabel = _c === void 0 ? true : _c;
      var labelComponent = react_1.default.createElement(Label_1.default, {
        id: this.searchLabelId,
        htmlFor: this.searchInputId
      }, label);

      if (hideLabel) {
        labelComponent = react_1.default.createElement(VisuallyHidden_1.default, null, labelComponent);
      }

      return labelComponent;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Search.prototype, "searchResults", {
    get: function get() {
      var _this = this;

      if (this.showSelectedResults) {
        var searchResultsComponent = react_1.default.createElement(SelectedResultsWrapper_1.default, null, this.selectedResults.map(function (result) {
          return react_1.default.createElement(SelectedResultPill_1.default, {
            key: "result-element-" + result.value,
            onClick: function onClick() {
              return _this.removeSelectedResult(result);
            },
            onKeyDown: function onKeyDown(e) {
              return _this.handlePillKeyDown(e, result);
            }
          }, react_1.default.createElement(SelectedResultGroup_1.default, null, react_1.default.createElement(Translate_1.default, null, result.group), ":"), react_1.default.createElement(SelectedResultValue_1.default, null, react_1.default.createElement(Translate_1.default, null, result.value)), react_1.default.createElement(SelectedResultClear_1.default, {
            asset: "base.search.selectedResultClear",
            onClick: function onClick() {
              return _this.SearchStore.reset();
            }
          }));
        }));
        return searchResultsComponent;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Search.prototype, "showSelectedResults", {
    get: function get() {
      var _a = this.props.showSelectedResults,
          showSelectedResults = _a === void 0 ? false : _a;
      return showSelectedResults;
    },
    enumerable: true,
    configurable: true
  });

  Search.prototype.onNavigation = function (key) {
    var _a = this.props.pageKeyTraverseSize,
        pageKeyTraverseSize = _a === void 0 ? 3 : _a;

    switch (key) {
      case shared_1.KEYS.UP_ARROW:
        if (this.SearchStore.showResults) {
          if (this.focusedIndex <= 0) {
            this.focusedIndex = this.results.length - 1;
          } else {
            this.focusedIndex = this.focusedIndex - 1;
          }
        } else {
          this.SearchStore.showResults = true;
        }

        break;

      case shared_1.KEYS.DOWN_ARROW:
        if (this.SearchStore.showResults) {
          this.focusedIndex = (this.focusedIndex + 1) % this.results.length;
        } else {
          this.SearchStore.showResults = true;
        }

        break;

      case shared_1.KEYS.PAGE_UP:
        if (this.SearchStore.showResults) {
          if (this.focusedIndex - pageKeyTraverseSize < 0 && this.focusedIndex !== 0) {
            this.focusedIndex = 0;
          } else if (this.focusedIndex - pageKeyTraverseSize < 0) {
            this.focusedIndex = this.results.length - 1;
          } else {
            this.focusedIndex = this.focusedIndex - pageKeyTraverseSize;
          }
        }

        break;

      case shared_1.KEYS.PAGE_DOWN:
        if (this.SearchStore.showResults) {
          if (this.focusedIndex === this.results.length - 1) {
            this.focusedIndex = 0;
          } else if (this.focusedIndex + pageKeyTraverseSize > this.results.length - 1) {
            this.focusedIndex = this.results.length - 1;
          } else {
            this.focusedIndex = (this.focusedIndex + pageKeyTraverseSize) % this.results.length;
          }
        }

        break;

      case shared_1.KEYS.HOME:
        if (this.SearchStore.showResults) {
          this.focusedIndex = 0;
        }

        break;

      case shared_1.KEYS.END:
        if (this.SearchStore.showResults) {
          this.focusedIndex = this.results.length - 1;
        }

        break;

      case shared_1.KEYS.ESCAPE:
        this.SearchStore.showResults = false;
        this.focusedIndex = -1;
        this.focusSearchInput = true;
        break;

      default:
        break;
    }

    this.setFocusedItem(this.focusedIndex);
  };

  Search.prototype.setFocusedItem = function (index) {
    var results = this.SearchStore.results;

    for (var i = 0; i < results.length; i++) {
      results[i].focused = index === i;
    }
  };

  Search.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        iconPosition = _a.iconPosition;
    var inputProps = {
      role: 'searchbox',
      id: this.searchInputId,
      type: 'text',
      value: this.term,
      focus: this.focusSearchInput,
      autoFocus: this.getAutoFocus(),
      onChange: this.onChange,
      onClick: function onClick() {
        return _this.SearchStore.displayResults;
      },
      onKeyDown: function onKeyDown(e) {
        return _this.handleKeyDown(e);
      },
      'aria-labelledby': this.searchLabelId,
      'aria-haspopup': this.SearchStore.showResults
    };
    var iconProps = {
      asset: this.getAsset(this.isSearching),
      'aria-hidden': true
    };
    var pillProps = this.pillProps; // Used to force a render for the focus and selected results

    this.focusedIndex;
    this.selectedResults;
    return react_1.default.createElement(Wrapper_1.default, {
      className: className
    }, react_1.default.createElement(Translate_1.TranslationContext.Consumer, null, function (translationContext) {
      // push translated placeholder onto inputProps
      var placeholder = _this.getPlaceholder(translationContext);

      Object.assign(inputProps, {
        placeholder: placeholder,
        'aria-label': placeholder
      });
      return react_1.default.createElement(react_1.default.Fragment, null, _this.searchLabel, react_1.default.createElement(SearchBar_1.default, {
        id: _this.searchBarId,
        "aria-expanded": _this.SearchStore.showResults
      }, iconPosition === 'left' && react_1.default.createElement(SearchIcon_1.default, __assign({}, iconProps)), _this.searchResults, pillProps && pillProps.pillPosition === 'left' && react_1.default.createElement(SearchPill_1.default, __assign({}, pillProps)), react_1.default.createElement(Input_1.default, __assign({}, inputProps)), _this.SearchStore.hasSelectedResults && react_1.default.createElement(SearchClear_1.default, {
        "aria-label": 'Clear',
        iconProps: {
          asset: 'base.search.cross'
        },
        onClick: function onClick() {
          return _this.SearchStore.clearSelectedResults();
        }
      }), !ksys_app_template_1.utils.typeChecks.isNullOrEmpty(_this.term) && !_this.SearchStore.hasSelectedResults && react_1.default.createElement(SearchClear_1.default, {
        "aria-label": 'Clear',
        iconProps: {
          asset: 'base.search.cross'
        },
        onClick: function onClick() {
          return _this.SearchStore.reset();
        }
      }), pillProps && pillProps.pillPosition === 'right' && react_1.default.createElement(SearchPill_1.default, __assign({}, pillProps)), iconPosition === 'right' && react_1.default.createElement(SearchIcon_1.default, __assign({}, iconProps))), _this.resultElementsComponent);
    }), this.SearchStore.showResults && react_1.default.createElement(ResultBackground_1.default, {
      onClick: function onClick() {
        _this.SearchStore.hideResults();
      }
    }));
  };

  __decorate([mobx_1.observable.ref], Search.prototype, "focusedIndex", void 0);

  __decorate([mobx_1.observable.ref], Search.prototype, "focusSearchInput", void 0);

  __decorate([mobx_1.computed], Search.prototype, "term", null);

  __decorate([mobx_1.computed], Search.prototype, "isSearching", null);

  __decorate([mobx_1.computed], Search.prototype, "pillProps", null);

  __decorate([mobx_1.computed], Search.prototype, "selectedResults", null);

  __decorate([mobx_1.action], Search.prototype, "removeSelectedResult", null);

  __decorate([mobx_1.computed], Search.prototype, "results", null);

  __decorate([mobx_1.computed], Search.prototype, "sortedResults", null);

  __decorate([mobx_1.computed], Search.prototype, "groupedResults", null);

  __decorate([mobx_1.computed], Search.prototype, "resultGroupedElements", null);

  __decorate([mobx_1.computed], Search.prototype, "resultElements", null);

  __decorate([mobx_1.computed], Search.prototype, "resultElementsComponent", null);

  __decorate([mobx_1.computed], Search.prototype, "searchLabel", null);

  __decorate([mobx_1.computed], Search.prototype, "searchResults", null);

  __decorate([mobx_1.computed], Search.prototype, "showSelectedResults", null);

  __decorate([mobx_1.action], Search.prototype, "onNavigation", null);

  __decorate([mobx_1.action], Search.prototype, "setFocusedItem", null);

  Search = __decorate([mobx_react_1.observer], Search);
  return Search;
}(shared_1.ComponentBase);

exports.Search = Search;
exports.default = shared_1.InjectedStyledComponent(Search, Search_meta_1.SEARCH_CATEGORY_KEY, Search_meta_1.SEARCH_COMPONENT_KEY);